import './App.css';
import { useState, useEffect } from 'react';
import Cookies from 'js-cookie';


function App() {
  const [articles, setArticles] = useState([]);
  const [rerender, setRerender] = useState();

  let links_clicked = [];
  if( Cookies.get('links_clicked') ) {
    links_clicked = Cookies.get('links_clicked').split(',');
  }

  function getArticles() {
    fetch("api.php", {method: "GET"})
      .then((response) => response.json())
      .then((data) => {
		setArticles(data);
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    getArticles();
	const interval = setInterval(() => { getArticles() }, 3 * 60 * 1000);
  }, []);

  const clearLanguageCookie = () => {
    Cookies.remove('links_clicked');
  };

  const handleClick = (link) => {
	if( !links_clicked.includes(link) ) {
		links_clicked.push(link);
		Cookies.set('links_clicked', links_clicked, { expires: 30 });
		setRerender(Symbol());
	}
  };

  return (
    <div>
		{articles.map((article) => (
			article.type === "rss" ? (
				<a key={article.lien} href={article.lien} className={(!links_clicked.includes(article.lien) ? "lien_article" : "lien_article_visited")} target="_blank" onClick={() => { handleClick(article.lien); }}>
					<article>
						<div className="row">
							<div className="image_article">
								<img src={"logo/" + (article.site) + ".png"} alt={"logo " + (article.site)} width="32" height="32" />
								<span className="texte_article"><strong>{article.titre}</strong></span>
							</div>
						</div>
					</article>
				</a>
            ) : (
				<a key={article.lien} href={article.lien} className={"lien_article " + (article.type)} target="_blank" onClick={() => { handleClick(article.lien); }}>
					<article>
						<div className="row">
							<div className="image_article">
								<img src={"logo/" + (article.site) + ".png"} alt={"logo " + (article.site)} width="32" height="32" />
								<span className="texte_article"><strong>{article.titre}</strong></span>
							</div>
						</div>
					</article>
				</a>
			)
          )
		)}
    </div>
  );
}

export default App;
